export const buildProvenance = { "commitHash": "82b301cdb78881fec37f3ef4f841b8a036a2a983", "branchName": "refs/heads/release/2024.3", "buildDate": "2024-11-04T17:08:02.579Z", "version": "2024.3.12932" };
